import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import htmlEscaper$1, { htmlEscaper } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { and, compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"campaign-properties-section\">\r\n</div>\r\n\r\n<div id=\"rewards-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":5,"column":36},"end":{"line":5,"column":50}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"and")||(depth0 && lookupProperty(depth0,"and"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"and","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":63,"column":8}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"video-jcr\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"video") : stack1),"===","TRAVEL",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":2},"end":{"line":6,"column":14}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"video") : stack1),"===","CASH",{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":10,"column":14}}})) != null ? stack1 : "")
    + "</div>\r\n<div class=\"row collapse content-container\">\r\n  <h2 class=\"small-12 column heading show-for-medium-up\" tabindex=\"0\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n  <div class=\"tab-container small-12 medium-12 large-12 clearfix\">\r\n    <div role=\"tablist\" tabindex=\"0\" class=\"tabs small-12 column\">\r\n      <button role=\"tab\" data-content=\"#earn-tab\" aria-selected=\"true\" tabindex=\"0\"\r\n         aria-label=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"label") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"labelRewards") : stack1), depth0)) != null ? stack1 : "")
    + "\" aria-controls=\"earn-tab\" class=\"tab-title active\" id=\"earn\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"label") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </button>\r\n      <button role=\"tab\" data-content=\"#redeem-tab\" aria-selected=\"false\" tabindex=\"-1\"\r\n         aria-label=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"label") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"labelRewards") : stack1), depth0)) != null ? stack1 : "")
    + "\" aria-controls=\"redeem-tab\" class=\"tab-title\" id=\"redeem\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"label") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </button>\r\n    </div>\r\n    <div class=\"tabs-content small-12 medium-12 large-12 column\">\r\n      <div class=\"content active clearfix row\" id=\"earn-tab\" role=\"tabpanel\" tabindex=\"0\" aria-labelledby=\"earn\">\r\n        <div class=\"column small-12 medium-12 large-8 tab-content-left cell\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n        <div class=\"column large-3 cell\">\r\n          "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"imageH") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":32,"column":10},"end":{"line":32,"column":36}}}))
    + "\r\n        </div>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"displaySwitch") : stack1),"===","ON",{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":8},"end":{"line":41,"column":20}}})) != null ? stack1 : "")
    + "      </div>\r\n\r\n      <div class=\"content clearfix row\" id=\"redeem-tab\" role=\"tabpanel\" tabindex=\"0\" aria-labelledby=\"redeem\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"video") : stack1),"===","TRAVEL",{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":46,"column":8},"end":{"line":58,"column":33}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + ((stack1 = (lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"redeemCinema") : stack1)) != null ? lookupProperty(stack1,"travelReward") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":5,"column":2},"end":{"line":5,"column":44}}})) != null ? stack1 : "")
    + "\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + ((stack1 = (lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"redeemCinema") : stack1)) != null ? lookupProperty(stack1,"cashReward") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":9,"column":2},"end":{"line":9,"column":42}}})) != null ? stack1 : "")
    + "\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"column small-12 medium-12 calculate\">\r\n          <a href=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"calcUrl") : stack1), depth0)) != null ? stack1 : "")
    + "\" id=\"calculate-rewards-link\" class=\"calculator-link\">\r\n            <span class=\"calculator-link-heading\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"calcHeadline") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n          </a>\r\n          <p class=\"calc-link-text\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"earn") : stack1)) != null ? lookupProperty(stack1,"calcModuleContent") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"column small-12 medium-7 border\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n        <div data-font=\"cnx-regular\" class=\"column small-12 medium-5 videoDIV\"\r\n          data-show-transcript=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"showTranscript") : stack1), depth0))
    + "\"\r\n          data-hide-transcript=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"hideTranscript") : stack1), depth0))
    + "\"></div>\r\n        ";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"video") : stack1),"===","CASH",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":51,"column":17},"end":{"line":58,"column":20}}})) != null ? stack1 : "")
    + " ";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n        <div class=\"column small-12 medium-7 border\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n        <div data-font=\"cnx-regular\" class=\"column small-12 medium-5 videoDIV\"\r\n          data-show-transcript=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"showTranscript") : stack1), depth0))
    + "\"\r\n          data-hide-transcript=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"hideTranscript") : stack1), depth0))
    + "\"></div>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"column small-12 medium-12 border\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"redeem") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n        ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":64,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/rewards-cc-module",
  "version": "4.0.3",
  "id": "rewardsCcModule",
  "containerID": "creditCardsRewardsCcModule",
  "moduleName": "credit-cards-rewards-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "rewards-cc-module",
  "data": {
    "init": "rewardsCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        and,
        compare,
        picture,
        json,
        htmlEscaper
      },
      "partials": {
        "rewards-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "rewards-cc-partial": renderTemplate
  },
  "helpers": {
    and,
    compare,
    picture,
    json,
    htmlEscaper
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * The rewardsCcModule Sparta Module.
 * @export
 * @class
 */
class rewardsCcModuleJS extends Module {
  /**
   * Creates an instance of rewardsCcModuleJS.
   * @param {Object} options inherited params
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('#rewards-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['rewards-cc-partial'];
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {undefined}
   */
  init() {
    let campaignProperties;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const {
        target
      } = this.settings;
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams
      }, {
        helpers: {
          htmlEscaper: htmlEscaper$1
        }
      });
      target.querySelector('.campaign-properties-section').innerHTML = renderedTemplate;
      this.bindEvents();
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });
    });
  }

  /**
   * Called in init() to set up click events on tab buttons via event delegation.
   * @returns {undefined}
   */
  bindEvents() {
    const tabContainer = this.settings.target.querySelector('.tab-container');
    if (tabContainer) {
      // click listener handles mouse click
      tabContainer.addEventListener('click', event => {
        if (event.target.tagName.toLowerCase() === 'button' && event.pointerType === 'mouse') {
          this.changeTab(event.target);
        }
      });

      // fetching tabs container 
      const tabList = this.settings.target.querySelector('[role="tablist"]');
      const tabs = tabList.querySelector('[role="tab"]');

      // keydown listener handles arrow keys for navigation of tabs/space keypress
      tabList.addEventListener('keydown', event => {
        const currentTab = document.activeElement;
        if (!currentTab || currentTab.getAttribute('role') !== 'tab') return;
        let newTab;
        switch (event.key.toLowerCase()) {
          case 'arrowright':
            newTab = currentTab.nextElementSibling || tabs[0];
            break;
          case 'arrowleft':
            newTab = currentTab.previousElementSibling || tabs[tabs.length - 1];
            break;
          case ' ':
            event.preventDefault();
            currentTab.click();
            this.changeTab(event.target);
            return;
        }
        if (newTab) newTab.focus();
      });
    }
  }

  /**
   * Called in init() to set up click events on tab buttons via event delegation.
   * @param {HTMLButtonElement} newActiveTab the tab that was clicked.
   * @returns {undefined}
   * TODO: This implementation should be replaced with the tabs helper
   * once the Credit Cards site is migrated to Helix. This patch version
   * addresses accessibility concerns raised in CFSSCMONEY-13438.
   * See: http://sparta/demo/tabs/
   */
  changeTab(newActiveTab) {
    // Get the tab that was active prior to click, and deactivate.
    const priorActiveTab = this.settings.target.querySelector('.tab-title.active');
    priorActiveTab.classList.remove('active');
    priorActiveTab.setAttribute('aria-selected', 'false');

    // Activate the tab that was clicked.
    newActiveTab.classList.add('active');
    newActiveTab.setAttribute('aria-selected', 'true');

    // Toggle display of tab panel content.
    const tabContent = this.settings.target.querySelector('.tabs-content');
    tabContent.querySelector('.content.active').classList.remove('active');
    tabContent.querySelector(`${newActiveTab.getAttribute('data-content')}`).classList.add('active');
  }
}
registerModuleClass({
  moduleClass: rewardsCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { rewardsCcModuleJS as default, moduleConfig };
